import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Settings2 } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";

interface TableSettingsDialogProps {
    isContainerMode: boolean;
    onContainerModeChange: (value: boolean) => void;
}

export const TableSettingsDialog: React.FC<TableSettingsDialogProps> = ({
    isContainerMode,
    onContainerModeChange,
}) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = React.useState(false);
    const [localContainerMode, setLocalContainerMode] = React.useState(isContainerMode);

    React.useEffect(() => {
        setLocalContainerMode(isContainerMode);
    }, [isContainerMode]);

    const handleSave = () => {
        onContainerModeChange(localContainerMode);
        setIsOpen(false);
    };

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger asChild>
                <Button variant="outline" size="icon">
                    <Settings2 className="h-4 w-4" />
                </Button>
            </DialogTrigger>
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>{t("common.tableSettings.title")}</DialogTitle>
                    <DialogDescription>
                        {t("common.tableSettings.description")}
                    </DialogDescription>
                </DialogHeader>

                <div className="space-y-4 py-4">
                    <div className="flex items-start justify-between space-x-4">
                        <div className="space-y-1">
                            <Label>{t("common.tableSettings.containerMode.title")}</Label>
                            <p className="text-sm text-muted-foreground">
                                {t("common.tableSettings.containerMode.description")}
                            </p>
                        </div>
                        <Switch
                            checked={localContainerMode}
                            onCheckedChange={setLocalContainerMode}
                        />
                    </div>
                </div>

                <DialogFooter>
                    <Button
                        variant="outline"
                        onClick={() => setIsOpen(false)}
                    >
                        {t("common.tableSettings.cancel")}
                    </Button>
                    <Button onClick={handleSave}>
                        {t("common.tableSettings.save")}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}; 